// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.4033 5.06068L16.9389 8.59622L22.5957 2.93936L21.1815 1.52515L16.9389 5.76779L14.8175 3.64647L13.4033 5.06068Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12.5 5C12.5 4.29442 12.6329 3.61987 12.8749 3H4V22.9432L12 17.2289L20 22.9432V10.1251C19.3801 10.3671 18.7056 10.5 18 10.5C14.9624 10.5 12.5 8.03757 12.5 5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-bookmark-checked-filled')
export default class BookmarkCheckedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bookmark-checked-filled',
    }
  }
}
